import React, { memo, useMemo } from 'react';
import { Select } from 'antd';
import styles from '../SelectRoomsRow.module.scss';
import { useDispatch } from 'react-redux';
import { useRequestFilterCommands } from '../../../../model/commandsContext';
import { compactMultiSelectTagProps } from '../../../primitives/selectTagProps';
import {
  createOptionsTypeFlatForRender,
  useSetFilterChanged,
} from '../lib/utils';

const SelectTypeFlat = ({ value, getPopupContainer, items }) => {
  const dispatch = useDispatch();
  const { setAddrTypeFlatValue } = useRequestFilterCommands();

  const setFilterChanged = useSetFilterChanged();

  const handleChange = (value) => {
    dispatch(setAddrTypeFlatValue(value));
    setFilterChanged();
  };

  const options = useMemo(() => createOptionsTypeFlatForRender(items), [items]);

  return (
    <Select
      {...compactMultiSelectTagProps}
      mode="multiple"
      allowClear={true}
      getPopupContainer={getPopupContainer}
      placeholder="Типы помещения"
      optionFilterProp="searchtext"
      optionLabelProp="label"
      style={{ width: 234 }}
      value={value}
      onChange={handleChange}
      dropdownClassName={styles.dropdownCN}
    >
      {options}
    </Select>
  );
};

export default memo(SelectTypeFlat);
